import { Component, OnInit, Input, Output, EventEmitter, isDevMode, ViewChild, ElementRef } from '@angular/core';
import { FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Subject, throwError } from 'rxjs';
import { GoogleTagManagerService } from 'angular-google-tag-manager';

import { CommonService } from '../../../../core/providers/forms/common.service';
import { catchError, take, takeUntil, tap } from 'rxjs/operators';
import { PresupuestoGuardarService } from '../../../../core/providers/services/presupuesto-guardar/presupuesto-guardar.service';
import { UtilsService } from '../../../services/utils/utils.service';
import { environment } from 'src/environments/environment';
import * as CryptoJS from 'crypto-js';
import EmergencyContactUtils from './emergency-contact-utils';
import { Numbers } from 'src/app/utils/constants';
import { ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { ProductIdCorreduria } from 'src/app/core/interfaces/producto-informacion.interface';

@Component({
  selector: 'app-emergency-contact',
  templateUrl: './emergency-contact.component.html',
  styleUrls: ['./emergency-contact.component.scss']
})
export class EmergencyContactComponent implements OnInit {
  tokenURL: any = '';
  redsysRedirectUrl: string = environment.redsysRedirectUrl;
  redsysBizumRedirectUrl: string = environment.redsysBizumRedirectUrl;
  @ViewChild('payform', { static: false }) payForm: ElementRef;
  @ViewChild('payBizumForm', { static: false }) payBizumForm: ElementRef;
  tpvParameters: any;
  bizumParams: any;
  Utils: EmergencyContactUtils;

  //#region Constructor
  /**
   * @ignore
   */
  constructor(
    private commons: CommonService,
    private utilsSrv: UtilsService,
    private budgetSrv: PresupuestoGuardarService,
    private gtmService: GoogleTagManagerService,
    private activatedRoute: ActivatedRoute
  ) {
    this.commons = commons;
    this.utilsSrv = utilsSrv;
    this.budgetSrv = budgetSrv;
    this.gtmService = gtmService;
    this.activatedRoute = activatedRoute;
    this.Utils = new EmergencyContactUtils(this.utilsSrv);
    this.activatedRoute.queryParams.subscribe((params: any) => {
      if (params.token !== undefined) {
        this.tokenURL = params.token;
      } else {
        this.tokenURL = '';
      }
    });

  }

  /**
   * @description Es el formulario
   */
  @Input() FORM_DATA: FormGroup;

  /**
   * @description Es la configuracion del formulario
   */
  @Input() FORM_CONFIG: any;

  /**
   * @description Es el paso del formulario
   */
  @Input() STEP: any;
  @Input() productosCorreduria: ProductIdCorreduria[] = [];
  @Output() CLICK_BTN: EventEmitter<'back' | 'next'> = new EventEmitter();
  @Output() INSURED_CHOOSED: EventEmitter<'Particular' | 'Empresa'> = new EventEmitter();
  finish: Subject<unknown> = new Subject();

  typeOwner: 'Particular' | 'Empresa';
  insureSelected: any;
  currentStep = 0;
  formDataValue: any;

  patternEmail: RegExp = this.commons.patternsForm('email');
  patternMobile: RegExp = this.commons.patternsForm('mobile');
  patternCP: RegExp = this.commons.patternsForm('cp');

  modalTPVTitle: string = this.utilsSrv.getTranslate('modalTPV.title');
  modalTPVStep1: string = this.utilsSrv.getTranslate('modalTPV.step1');
  modalTPVDetail1: string = this.utilsSrv.getTranslate('modalTPV.detail1');
  modalTPVStep2: string = this.utilsSrv.getTranslate('modalTPV.step2');
  modalTPVDetail2: string = this.utilsSrv.getTranslate('modalTPV.detail2');
  modalTPVDetail22: string = this.utilsSrv.getTranslate('modalTPV.detail2-2');
  modalTPVButton: string = this.utilsSrv.getTranslate('modalTPV.button');

  bizumTPVTittle: string = this.utilsSrv.getTranslate('bizumTPV.tittle');
  bizumTPVStep1: string = this.utilsSrv.getTranslate('bizumTPV.step1');
  bizumTPVDetail1: string = this.utilsSrv.getTranslate('bizumTPV.detail1');
  bizumTPVStep2: string = this.utilsSrv.getTranslate('bizumTPV.step2');
  bizumTPVDetail2: string = this.utilsSrv.getTranslate('bizumTPV.detail2');
  bizumTPVDetail22: string = this.utilsSrv.getTranslate('bizumTPV.detail2-2');
 // bizumTPVButton: string = this.utilsSrv.getTranslate('bizumTPV.button');

  idPresu = 0;
  polizaData: any;
  clickBtnValue = '';
  public showModal = false;
  public showModalT = false;
  displayModal: boolean;
  displayModal2: boolean;
  displayErrorTerms: boolean;
  displayErrorAdec = false;
  showModalAdec = false;
  precioProducto: number;
  showTPV = false;
  prefixchanged: { name: string, value: any};
  errorDesc = '';
  tarjetaSelected = false;
  bizumSelected = false;
  disabledButton = false;

  /**
   * @description Metodo inicio
   */
  ngOnInit() {
    this.currentStep = this.STEP;
    this.getProductChoosed();
    this.initSubs();
    this.setValidator();
    window.scrollTo(0, 0);
  }

  /**
   * @description Definición inicial del paso
   */
  initSubs(): void {
    this.formDataValue = this.FORM_DATA.get(this.insureSelected).value;

    this.FORM_DATA.get(this.insureSelected).valueChanges
      .pipe(
        takeUntil(this.finish),
        tap(() => {
          this.formDataValue = this.FORM_DATA.get(this.insureSelected).value;
        })
      ).subscribe();

    this.FORM_DATA.get([this.insureSelected, 'emergencyContact', 'telephone']).setValue('');
  }

  /**
   * @description Recupera el tipo de formulario
   */
  getProductChoosed(): void {
    if (this.FORM_DATA) {
      this.insureSelected = this.FORM_DATA.get('insureSelected').value.chosed;
    }
  }
  /**
   * @description Datos del tomador
   */
  setDefaultValueTypeOwner(): void {
    if (this.FORM_DATA && this.FORM_CONFIG) {
      this.typeOwner = this.FORM_DATA.get(this.FORM_CONFIG.typeOwner.linkFormPath).value;
      if (!this.typeOwner) {
        this.FORM_DATA
          .get(this.FORM_CONFIG.typeOwner.linkFormPath)
          .setValue(this.FORM_CONFIG.typeOwner.value);
      }
    }
  }
  /**
   * @description botón siguiente o anterior
   */
  public clickButton(ev: 'back' | 'next'): void {
    if (ev === 'next') {
      this.clickBtnValue = 'next';
      if (this.FORM_DATA.valid) {
        // this.callPresupuestoGuardar();
        this.tarjetaSelected = false;
        this.bizumSelected = false;
        this.showModalDialog();
      } else {
        const formValues: any = this.FORM_DATA.get(this.insureSelected).value;
        const acceptTerms: boolean = formValues.emergencyContact.acceptTerms;
        const adequacyOfProduct: boolean = formValues.emergencyContact.adequacyOfProduct;
        switch (acceptTerms) {
          case (false):
            // mostrar modal aviso
            this.showModalTerms();
            break;
          case (true && adequacyOfProduct === false):
            // mostrar modal
            this.showModalAdecuacy();
            break;
          default:
              break;
        }
      }
    } else {
      this.clickBtnValue = 'back';
      localStorage.removeItem('stepThanks');
      this.removeValidator();
      this.CLICK_BTN.emit(ev);
    }
  }
  /**
   * @description Definir el tipo de tomador: Particular o Empresa
   */
  public emitInsuredChoosed(ev: 'Particular' | 'Empresa'): void {
    if (this.FORM_DATA) {
      this.FORM_DATA.get(this.FORM_CONFIG.typeOwner.linkFormPath).setValue(ev);
      this.INSURED_CHOOSED.emit(ev);
    }
  }
  /**
   * @description Recupera el tipo de tomador: Particular o Empresa
   */
  public getInsuredChoosed(): 'Particular' | 'Empresa' {
    if (this.FORM_DATA) {
      return this.FORM_DATA.get(this.FORM_CONFIG.typeOwner.linkFormPath).value;
    }
  }
  // /**
  //  * @description Devuelve los valores del formulario
  //  */
  // getFormValue(prop: string[]): any {
  //   if (this.FORM_DATA) {
  //     return this.FORM_DATA.get(prop).value;
  //   }
  // }
  /**
   * @description asignar las validaciones del paso
   */
  public setValidator(): void {
    this.FORM_DATA.get(this.FORM_CONFIG.telephone.linkFormPath).setValidators([Validators.pattern(this.patternMobile)]);
    this.FORM_DATA.get(this.FORM_CONFIG.acceptTerms.linkFormPath).setValidators([Validators.required]);
    this.FORM_DATA.get(this.FORM_CONFIG.adequacyOfProduct.linkFormPath).setValidators([Validators.required]);
    this.FORM_DATA.get(this.FORM_CONFIG.treatmentOfData.linkFormPath).setValidators([this.validTreatment]);

    this.FORM_DATA.get(this.FORM_CONFIG.telephone.linkFormPath).updateValueAndValidity();
    this.FORM_DATA.get(this.FORM_CONFIG.acceptTerms.linkFormPath).updateValueAndValidity();
    this.FORM_DATA.get(this.FORM_CONFIG.adequacyOfProduct.linkFormPath).updateValueAndValidity();
    this.FORM_DATA.get(this.FORM_CONFIG.treatmentOfData.linkFormPath).updateValueAndValidity();
  }

  /**
   * Validate if the treatment of data is marked
   * @param control control treatment
   * @returns validationError
   */
  validTreatment(control: FormControl): ValidationErrors {
    let validationErrors: ValidationErrors = null;
    if (control.value[0].Aceptacion === '0') {
      validationErrors = { opcionInvalida: true };
    }
    return validationErrors;
  }

  /**
   * @description asignar las validaciones del paso
   */
  public removeValidator(): void {
    this.FORM_DATA.get(this.FORM_CONFIG.telephone.linkFormPath).clearValidators();
    this.FORM_DATA.get(this.FORM_CONFIG.acceptTerms.linkFormPath).clearValidators();
    this.FORM_DATA.get(this.FORM_CONFIG.adequacyOfProduct.linkFormPath).clearValidators();
    this.FORM_DATA.get(this.FORM_CONFIG.treatmentOfData.linkFormPath).clearValidators();

    this.FORM_DATA.get(this.FORM_CONFIG.telephone.linkFormPath).updateValueAndValidity();
    this.FORM_DATA.get(this.FORM_CONFIG.acceptTerms.linkFormPath).updateValueAndValidity();
    this.FORM_DATA.get(this.FORM_CONFIG.adequacyOfProduct.linkFormPath).updateValueAndValidity();
    this.FORM_DATA.get(this.FORM_CONFIG.treatmentOfData.linkFormPath).updateValueAndValidity();
  }

  /**
   * changePrefix
   */
  changePrefix(): void {
    let formData: any;
    if (this.FORM_DATA.value.individualTravelAsistance) {
      formData = this.FORM_DATA.value.individualTravelAsistance;
    } else {
      if (this.FORM_DATA.value.sportTravelAsistance) {
        formData = this.FORM_DATA.value.sportTravelAsistance;
      } else {
        switch (this.FORM_DATA.value.particularTravelAsistance) {
          case true:
            formData = this.FORM_DATA.value.particularTravelAsistance;
            break;
          case false && this.FORM_DATA.value.incomingStudentsTravelAsistance:
            formData = this.FORM_DATA.value.incomingStudentsTravelAsistance;
            break;
          default:
            break;
        }
      }
    }

    if (formData.emergencyContact.prefix.id === '+34' || formData.emergencyContact.prefix === 'España (+34)') {
      this.prefixchanged = { name: 'prefix', value: '9' };
    } else {
      this.prefixchanged = { name: 'prefix', value: '13' };
    }
    this.FORM_DATA.get([this.insureSelected, 'emergencyContact', 'telephone']).setValue('');
  }

  /**
   * @description getCountryDestiny
   * @returns any
   */
  getCountryDestiny(): string {
    return this.Utils.getCountryDestiny(this.FORM_DATA, this.insureSelected);
  }

  /**
   * @description identificar el tiempo del viaje
   * @returns number
   */
  insuranceTravelers(typeT: string): number {
    let auxDays = 0;
    if (typeT === 'anual' && this.formDataValue.insuranceTime < Numbers.number365) {
      auxDays = Numbers.number365;
    } else if (typeT === '90' && this.formDataValue.insuranceTime < Numbers.number365) {
      auxDays = Numbers.number365;
    } else {
      auxDays = this.formDataValue.insuranceTime;
    }

    return auxDays;
  }

  /**
   * @description numberOfInsuredsRiskGratedThen0
   * @params numberOfInsuredsOlder
   * @params isBothMenor
   * @params isBothEqual
   * @params is70Menor
   * @params is70Equal
   * @params viajerosNormales
   * @params viajerosPracticasDeRiesgo
   * @params viajerosMayor70Años
   * @params isSportMenor
   * @params isSportEqual
   */
  /* numberOfInsuredsRiskGratedThen0(numberOfInsuredsOlder: any, isBothMenor: any, isBothEqual: any, is70Menor: any, is70Equal: any,
                                  viajerosNormales: any, viajerosPracticasDeRiesgo: any, viajerosMayor70Años: any, isSportMenor: any,
                                  isSportEqual: any) {
    let viajerosType = [];
    if (numberOfInsuredsOlder > 0) {
      viajerosType = this.numberOfInsuredsOlderGratedThen0(isBothMenor, isBothEqual, is70Menor, is70Equal,
        viajerosNormales, viajerosPracticasDeRiesgo, viajerosMayor70Años);
    } else {
      if (isSportMenor || isSportEqual) {
        viajerosType = [
          viajerosPracticasDeRiesgo
        ];
        if (isSportMenor) {
          viajerosType.push(viajerosNormales);
        }
      }
    }
    return viajerosType;
  } */
  /**
   * @description numberOfInsuredsOlderGratedThen0
   * @params isBothMenor
   * @params isBothEqual
   * @params is70Menor
   * @params is70Equal
   * @params viajerosNormales
   * @params viajerosPracticasDeRiesgo
   * @params viajerosMayor70Años
   */
  // numberOfInsuredsOlderGratedThen0(isBothMenor: any, isBothEqual: any, is70Menor: any, is70Equal: any,
  //                                  viajerosNormales: any, viajerosPracticasDeRiesgo: any, viajerosMayor70Años: any): any[] {
  //   let viajerosType: any[] = [];
  //   if (isBothMenor || isBothEqual) {
  //     viajerosType = [
  //       viajerosPracticasDeRiesgo,
  //       viajerosMayor70Años
  //     ];
  //     if (isBothMenor) {
  //       viajerosType.push(viajerosNormales);
  //     }
  //   } else {
  //     if (is70Menor || is70Equal) {
  //       viajerosType = [
  //         viajerosMayor70Años
  //       ];
  //       if (is70Menor) {
  //         viajerosType.push(viajerosNormales);
  //       }
  //     }
  //   }
  //   return viajerosType;
  // }

  /**
   * @description Generar el presupuesto
   */
  callPresupuestoGuardar(): void {
    let isTarjeta = true;
    if (this.tarjetaSelected === true) {
      isTarjeta = true;
    } else {
      isTarjeta = false;
    }

    this.disabledButton = true;
    const presu: any = this.Utils.callPresupuestoGuardar(this.formDataValue, this.insureSelected, isTarjeta, this.productosCorreduria);
    localStorage.setItem('tiempoInicio', (new Date().getTime()).toString());
    this.budgetSrv.postBudgetSave(presu)
      .pipe(take(1))
      .subscribe((budgetSaved: any) => {
        localStorage.setItem('tiempoFin', (new Date().getTime()).toString());
        this.idPresu = 0;
        if (budgetSaved.idError !== 0) {
          this.errorDesc = budgetSaved.desError;
        } else {
          this.errorDesc = '';
        }
        if (budgetSaved.idPresupuesto !== undefined) { this.idPresu = budgetSaved.idPresupuesto; }
        if (this.idPresu > 0) {
          localStorage.setItem('email', this.formDataValue.insuredData.email);
          this.showModalDialog();
          this.clickTpv();
        }
      });
  }
  /**
   * @description Recuperar estado
   */
  public getModalState(): boolean {
    return this.showModal;
  }
  /**
   * @description Modal terminos y condiciones
   */
  showModalTerms(): void {
    this.displayErrorTerms = true;
    this.showModalT = this.displayErrorTerms;
  }
  /**
   * @description Modal adecuación
   */
  showModalAdecuacy(): void {
    this.displayErrorAdec = true;
    this.showModalAdec = this.displayErrorAdec;
  }
  /**
   * @description Modal pasos del pago
   */
  showModalDialog(): void {
    this.displayModal = true;
    this.showModal = this.displayModal;
  }
  /**
   * @description Modal TPV
   */
  showModalDialog2(): void {
    this.displayModal2 = true;
  }

  /**
   * CallPresupuestoGuardar
   */
  clickPreTpv(): void {
    this.callPresupuestoGuardar();
  }
  /**
   * @description Pago
   */
  clickTpv(): void {
    this.showTPV = true;
    this.precioProducto = parseFloat(this.formDataValue.insuranceType.price);

    // Enviar a TPV
    const urlRes: any = this.getUrlRes();
    let urlko: string = urlRes.urlko;
    if (isDevMode()) { urlko = urlRes.urlko; }
    let urlok: string = urlRes.urlok;
    if (isDevMode()) { urlok = urlRes.urlok; }
    const precioString: string = (this.precioProducto.toFixed(Numbers.number2)).toString();
    const prodFinal = environment.endpoints.urlBaseTPV + 'Productos/Confirmacion_pedido.aspx';
    const urlMerchant: string = prodFinal;
    const precioSinComas: string = precioString.replace('.', '');

    const merchantParams: any = {
      DS_MERCHANT_AMOUNT: precioSinComas,
      DS_MERCHANT_CURRENCY: '978',
      DS_MERCHANT_ORDER: this.idPresu.toString(),
      DS_MERCHANT_MERCHANTCODE: '014342521',
      DS_MERCHANT_TRANSACTIONTYPE: '0',
      DS_MERCHANT_TERMINAL: '1',
      DS_MERCHANT_MERCHANTURL: urlMerchant,
      DS_MERCHANT_URLKO: urlko,
      DS_MERCHANT_URLOK: urlok
    };

    const dsMerchantParameters: CryptoJS.lib.WordArray = CryptoJS.enc.Utf8.parse(JSON.stringify(merchantParams));
    const merchanBase64: string = dsMerchantParameters.toString(CryptoJS.enc.Base64);
    const comercekey: string = environment.redsysKey;
    const comercekeyB64: CryptoJS.lib.WordArray = CryptoJS.enc.Base64.parse(comercekey);
    const iv: CryptoJS.lib.WordArray = CryptoJS.enc.Hex.parse('0000000000000000');
    const cipher: CryptoJS.lib.CipherParams = CryptoJS.TripleDES.encrypt(merchantParams.DS_MERCHANT_ORDER, comercekeyB64, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.ZeroPadding
    });

    const signature: CryptoJS.lib.WordArray = CryptoJS.HmacSHA256(merchanBase64, cipher.ciphertext);
    const signatureBase64: string = signature.toString(CryptoJS.enc.Base64);

    this.tpvParameters = {
      Ds_MerchantParameters: merchanBase64,
      Ds_Signature: signatureBase64,
      Ds_SignatureVersion: 'HMAC_SHA256_V1'
    };

    // Bizum
    const merchantParamsBizum: any = {
      DS_MERCHANT_AMOUNT: precioSinComas, // Para pruebas no puede superar 10e precioSinComas,
      DS_MERCHANT_CURRENCY: '978',
      DS_MERCHANT_ORDER: this.idPresu.toString(),
      DS_MERCHANT_MERCHANTCODE: '014342521',
      DS_MERCHANT_TRANSACTIONTYPE: '0',
      DS_MERCHANT_TERMINAL: '1',
      DS_MERCHANT_MERCHANTURL: urlMerchant,
      DS_MERCHANT_PAYMETHODS: 'z',
      DS_MERCHANT_URLKO: urlko,
      DS_MERCHANT_URLOK: urlok
    };

    const dsMerchantParametersBizum: CryptoJS.lib.WordArray = CryptoJS.enc.Utf8.parse(JSON.stringify(merchantParamsBizum));
    const merchanBase64Bizum: string = dsMerchantParametersBizum.toString(CryptoJS.enc.Base64);
    const cipherBizum: CryptoJS.lib.CipherParams = CryptoJS.TripleDES.encrypt(merchantParamsBizum.DS_MERCHANT_ORDER, comercekeyB64, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.ZeroPadding
    });

    const signatureBizum: CryptoJS.lib.WordArray = CryptoJS.HmacSHA256(merchanBase64Bizum, cipherBizum.ciphertext);
    const signatureBase64Bizum: string = signatureBizum.toString(CryptoJS.enc.Base64);

    this.bizumParams = {
      Ds_MerchantParameters: merchanBase64Bizum,
      Ds_Signature: signatureBase64Bizum,
      Ds_SignatureVersion: 'HMAC_SHA256_V1'
    };

    setTimeout(() => {
      localStorage.setItem('pay', 'true');
      localStorage.setItem('budget', this.idPresu.toString());
      localStorage.setItem('ndc', this.formDataValue.insuredData.documentNumber.toString());
      this.datalayer2();
      this.datalayer(this.idPresu, parseFloat(this.formDataValue.insuranceType.price));
      localStorage.setItem('tiempoRedireccion', (new Date().getTime()).toString());
      if (this.bizumSelected) {
        this.payBizumForm.nativeElement.submit();
      } else {
        this.payForm.nativeElement.submit();
      }

      // Cerrar modal
      this.displayModal = false;
    }, Numbers.number800);
  }

  /**
   * getUrlRes
   * @returns urlRes
   */
  getUrlRes(): {urlko: string, urlok: string} {
    const auxLocation = location.origin + location.pathname;
    let urlRes: any = {
      urlko: auxLocation + '?success=false',
      urlok: auxLocation + '?success=true'
    };
    if (this.tokenURL === '') {
      urlRes = {
        urlko: auxLocation + '?success=false',
        urlok: auxLocation + '?success=true'
      };
    } else {
      urlRes = {
        urlko: auxLocation + '?token=' + this.tokenURL + '&success=false',
        urlok: auxLocation + '?token=' + this.tokenURL + '&success=true'
      };
    }
    return urlRes;
  }

  /**
   * @description asignar evento analítica
   */
  datalayer(id: any, price: any): void {
    const formName: any = this.FORM_DATA.get('insureSelected').value;
    const formNameS = 'seguro de asistencia viajes ' + formName.layerName;
    const actionField: any = {
      id: id.toString(),
      affiliation: 'Credit Card',
      revenue: (price.toFixed(Numbers.number2)).toString(),
      tax: '-'
    };
    const productLayer: any = {
      name: formNameS,
      id: id.toString(),
      price: (price.toFixed(Numbers.number2)).toString(),
      brand: formName.layerName,
      category: 'viajes',
      variant: '-',
      quantity: 1,
      list: 'contrata_online'
    };
    const datalayerD: any = {
      event: 'ev_addToCart',
      ecommerce: {
        currencyCode: 'EUR',
        add: {
          products: [productLayer]
        }
      }
    };
    localStorage.removeItem('layer1');
    localStorage.removeItem('layer2');
    localStorage.setItem('layer1', JSON.stringify(actionField));
    localStorage.setItem('layer2', JSON.stringify(productLayer));
    // dataLayer.push(datalayerD);
    this.gtmService.pushTag(datalayerD);
  }

  /**
   * @description asignar evento analítica
   */
  datalayer2(): void {
    const formName: any = this.FORM_DATA.get('insureSelected').value;
    const datalayerD: any = {
      event: 'ev_tarificacion',
      event_category: 'tarificacion',
      event_action: formName.layerName,
      event_label: 'gestion_de_polizas',
      categoria_seguro: 'viajes',
      paso: 't5'
    };
    this.gtmService.pushTag(datalayerD);
  }

  /**
   * @description asigna el tipo de pago seleccionado
   */
  clickTarjetaTpv(): void {
    if (this.tarjetaSelected === false) {
      this.tarjetaSelected = !this.tarjetaSelected;
      this.bizumSelected = false;
    }
  }

  /**
   * @description asigna el tipo de pago seleccionado
   */
  clickBizumTpv(): void {
    if (this.bizumSelected === false) {
      this.bizumSelected = !this.bizumSelected;
      this.tarjetaSelected = false;
    }
  }
}
